import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./motion";
import { useTranslate } from "../context/TranslateContext";
import { TIMELINE } from "../mock/data";

export const History = () => {
  const { t } = useTranslate();
  const listenText = "From Raja Harishchandra in 1913 to the streaming age, Indian cinema spans more than a century. Explore the eras, movements and technologies that shaped a hundred years of storytelling.";

  return (
    <section id="history" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Overline>Cinema History</Overline>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
              {t("A century of ")}<span className="italic text-gradient-gold">{t("moving pictures")}</span>
            </h2>
            <Link to="/article/history-1931" data-testid="read-turning-points"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/50 px-5 py-2.5 font-body text-sm text-gold transition-colors hover:bg-gold/10">
              {t("Read: Five Turning Points in Indian Cinema")}
            </Link>
          </div>
          
        </div>

        <div className="relative">
          <div className="absolute left-0 top-3 hidden h-px w-full bg-edge md:block" />
          <div className="grid grid-cols-1 gap-10 md:grid-cols-6 md:gap-6">
            {TIMELINE.map((e, i) => (
              <Reveal key={e.year} delay={i * 0.05}>
                <div className="relative" data-testid={`timeline-${i}`}>
                  <div className="mb-4 hidden h-3 w-3 rounded-full bg-gold ring-4 ring-gold/20 md:block" />
                  <div className="font-display text-3xl font-semibold text-gradient-gold md:text-4xl">{e.year}</div>
                  <h3 className="mt-2 font-body text-base font-medium text-cream">{t(e.title)}</h3>
                  <p className="mt-1 font-body text-sm leading-relaxed text-ash">{t(e.note)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
